import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

import Section from "../../../components/ui/Section.jsx";
import { sponsors } from "../assets";

// Unlinked from `material-kit-pro-react`: data-driven responsive logo grid built
// from our own brand-themed styles + MUI v3 Grid (dropped `Grid`/`ecommerceStyle`).
const styles = {
  logoCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px"
  },
  link: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  },
  logo: {
    maxWidth: "100%",
    maxHeight: "95px",
    objectFit: "contain",
    filter: "grayscale(100%)",
    opacity: 0.75,
    transition: "filter 0.3s ease, opacity 0.3s ease, transform 0.3s ease",
    "&:hover": {
      filter: "grayscale(0%)",
      opacity: 1,
      transform: "scale(1.06)"
    }
  }
};

function SectionSponsors({ classes }) {
  return (
    <Section title="Contamos con el Apoyo de:">
      <Grid container spacing={16} alignItems="center" justify="center">
        {sponsors.map(sponsor => {
          const image = (
            <img
              className={classes.logo}
              src={sponsor.logo}
              alt={sponsor.name}
              title={sponsor.name}
            />
          );
          return (
            <Grid
              item
              key={sponsor.name}
              xs={6}
              sm={3}
              md={2}
              className={classes.logoCell}
            >
              {sponsor.url ? (
                <a
                  className={classes.link}
                  href={sponsor.url}
                  target="_blank"
                  rel="external nofollow noopener noreferrer"
                >
                  {image}
                </a>
              ) : (
                image
              )}
            </Grid>
          );
        })}
      </Grid>
    </Section>
  );
}

SectionSponsors.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SectionSponsors);



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/Sections/SectionSponsors.jsx